/* eslint-disable */
const BASE_CONF = {
  gutterWidth: 1,
  outerMargin: 2,
  container: {
    sm: 46,
    md: 61,
    lg: 76
  }
};

export const DIMENSION = { xs: 'xs', sm: 'sm', md: 'md', lg: 'lg' };

export const DIMENSION_NAMES = [
  DIMENSION.xs,
  DIMENSION.sm,
  DIMENSION.md,
  DIMENSION.lg
];

export default function config() {
  return BASE_CONF;
}
